import { isAllowedChatLinkHref } from 'components/@home/@messages/ChatPanel/SendForm/controls/ChatField/ChatInput/contentEditableSerializers';

/**
 * Find nearest allowed <a> ancestor inside the contenteditable boundary.
 */
export function findClosestAllowedLink(node, boundary) {
  let n = node?.nodeType === Node.ELEMENT_NODE ? node : node?.parentElement;
  while (n && n !== boundary) {
    if (n.nodeType === Node.ELEMENT_NODE && (n.tagName || '').toLowerCase() === 'a') {
      const href = n.getAttribute('href');
      if (href && isAllowedChatLinkHref(href)) return n;
    }
    n = n.parentElement;
  }
  return null;
}

/**
 * Replace <a> with its children (unwrap).
 */
export function unwrapChatLink(anchorEl) {
  if (!anchorEl?.parentNode) return;
  const parent = anchorEl.parentNode;
  while (anchorEl.firstChild) {
    parent.insertBefore(anchorEl.firstChild, anchorEl);
  }
  parent.removeChild(anchorEl);
}
